import React from "react";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import FolderIcon from "@mui/icons-material/Folder";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { handleNestedLevelClick } from "./SitesPageUtils/handleNestedLevelClick";
import Tooltip from "@mui/material/Tooltip";
import { useSitesPageStore } from "./sitesPageStore/sitesPageStore";
import { safeSetItem } from "../../../utils/localStorageUtils";

interface NestedListItemProps {
  arrayItem: any;
  selectedIndex: any;
  setPage: any;
  setCurrentTitle: any;
  levelName: any;
  setSelectedIndex: any;
  setRenderedRows: any;
  setPageLoading: any;
  navigate: any;
  indentNumber: any;
  setSiteBreadcrumbs: any;
  navBarCollapsed: boolean;
  setSelected: any;
  setSelectedGroupListName: any;
  setEditableGroupSelected: any;
}

export const NestedListItem: React.FC<NestedListItemProps> = ({
  arrayItem,
  selectedIndex,
  setPage,
  setCurrentTitle,
  levelName,
  setSelectedIndex,
  setRenderedRows,
  setPageLoading,
  navigate,
  indentNumber,
  // maxWordLength, // This prop is passed but not visibly used in the text slicing logic below.
  // The existing logic uses hardcoded values (18 and 15).
  setSiteBreadcrumbs,
  navBarCollapsed,
  setSelected,
  setSelectedGroupListName,
  setEditableGroupSelected,
}) => {
  React.useEffect(() => {
    // Set selected item in localStorage when arrayItem changes
    // Store only essential data to prevent quota exceeded errors
    const essentialData = {
      id: arrayItem.id,
      name: arrayItem.name,
      parent: arrayItem.parent,
      parent_account: arrayItem.parent_account,
    };

    safeSetItem("selectedItemSiteGroupList", essentialData, {
      maxRetries: 1,
      clearOnQuotaExceeded: true,
      compress: true,
    });
  }, [arrayItem]);

  const {
    getSelectedGroupCounts,
    selectedGroupCounts,
    fetchingSelectedGroupCounts,
  } = useSitesPageStore();

  let tooltipContent = null;

  if (fetchingSelectedGroupCounts) {
    tooltipContent = <div>Loading counts...</div>;
  } else if (selectedGroupCounts && selectedGroupCounts.id === arrayItem.id) {
    const hasSubGroupsCount = selectedGroupCounts.sub_groups !== undefined;
    const hasSitesCount = selectedGroupCounts.sites !== undefined;

    if (hasSubGroupsCount || hasSitesCount) {
      tooltipContent = (
        <div>
          <div>{arrayItem.name}</div>
          {hasSubGroupsCount && (
            <div>{`Sub Groups: ${selectedGroupCounts.sub_groups}`}</div>
          )}
          {hasSitesCount && <div>{`Sites: ${selectedGroupCounts.sites}`}</div>}
        </div>
      );
    }
    // If no relevant counts, tooltipContent remains null, and the tooltip will not be shown.
  }

  return (
    <Tooltip
      title={tooltipContent}
      placement="right"
      onOpen={() => {
        getSelectedGroupCounts(navigate, arrayItem.id);
      }}
    >
      <ListItemButton
        onClick={() => {
          const expandClick = !selectedIndex[levelName].includes(arrayItem.id);
          handleNestedLevelClick(
            setPage,
            setCurrentTitle,
            arrayItem.name,
            arrayItem.id,
            selectedIndex,
            levelName,
            setSelectedIndex,
            setRenderedRows,
            setPageLoading,
            navigate,
            setSiteBreadcrumbs,
            setSelected,
            setSelectedGroupListName,
            setEditableGroupSelected,
            expandClick
          );
        }}
        sx={{ pl: indentNumber }}
      >
        <ListItemIcon>
          <FolderIcon />
        </ListItemIcon>
        {arrayItem.name.length < 18 || navBarCollapsed ? (
          <ListItemText
            primary={`${arrayItem.name}`}
            primaryTypographyProps={{
              fontSize: 14,
              fontFamily: "Mulish",
            }}
          />
        ) : (
          <ListItemText
            primary={`${arrayItem.name.slice(0, 15)}...`}
            primaryTypographyProps={{
              fontSize: 14,
              fontFamily: "Mulish",
            }}
          />
        )}
        {selectedIndex[levelName].includes(arrayItem.id) ? (
          <ExpandLess />
        ) : (
          <ExpandMore />
        )}
      </ListItemButton>
    </Tooltip>
  );
};
